import { Navigate, Outlet } from 'react-router-dom';

export default function RequireContractor({ user }) {
 if (!user) return <Navigate to="/login" replace />;
 if (user.role !== 'contractor') return <Navigate to="/" replace />;
 return <Outlet />;
}
